export const Models = {
    MESSAGE_DOMAIN_SENDERS: 'message_domain_senders',
    MESSAGE_NUMBERS: 'message_numbers',
};
